import { useState } from "react"
import { Head, useForm, router } from "@inertiajs/react"
import { Card, CardContent } from "@/components/ui/card"
import { Header } from "@/components/header"
import { FileUploadCard } from "@/components/file-upload-card"
import { SampleFormFields } from "@/components/sample-form"
import type Sample from "@/types/generated/Sample"
import type { TagOption } from "@/types"

type Props = {
  sample: Sample
  available_keys: string[]
  popular_tags: TagOption[]
}

export default function Edit({ sample, available_keys, popular_tags }: Props) {
  const [customTags, setCustomTags] = useState<string[]>([])

  const { data, setData, put, processing, errors, transform } = useForm({
    title: sample.title,
    description: sample.description || "",
    bpm: sample.bpm?.toString() || "",
    key: sample.key || "",
    tag_ids: sample.tags.map((t) => t.id),
    new_tags: [] as string[],
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    transform((data) => ({ sample: data }))
    put(`/samples/${sample.id}`)
  }

  return (
    <div className="min-h-screen">
      <Head title={`Edit ${sample.title}`} />
      <Header />

      <main className="container mx-auto px-4 py-8 max-w-2xl">
        <h1 className="text-2xl font-mono font-bold mb-6">EDIT SAMPLE</h1>

        <form onSubmit={handleSubmit}>
          <Card>
            <CardContent className="p-6 space-y-6">
              <div>
                <FileUploadCard
                  file={{
                    key: "",
                    fileName: sample.file_name,
                    fileSize: sample.file_size,
                    contentType: "",
                  }}
                />
                <p className="text-xs text-muted-foreground mt-2">
                  File cannot be changed
                </p>
              </div>

              <SampleFormFields
                data={data}
                errors={errors}
                onChange={setData}
                availableKeys={available_keys}
                popularTags={popular_tags}
                customTags={customTags}
                onCustomTagsChange={(tags) => {
                  setCustomTags(tags)
                  setData("new_tags", tags)
                }}
                submitLabel={processing ? "Saving..." : "Save Changes"}
                processing={processing}
                onCancel={() => router.visit(`/samples/${sample.id}`)}
              />
            </CardContent>
          </Card>
        </form>
      </main>
    </div>
  )
}
